import { TTileSkeletonProps } from './types';

export const TitleSkeleton: React.FC<TTileSkeletonProps> = ({ height = 24 }) => {
  return (
    <div className="w-full animate-pulse delay-100 my-3">
      <div className="w-1/3 h-8 bg-gray-200 rounded" style={{ height: `${height}px` }}></div>
    </div>
  );
};
